import { BasicButton } from "@goodgamestudios/asset-globals";

import { BasicCustomCursor, EnvGlobalsHandler } from "@goodgamestudios/core";
import { IEnvironmentGlobals } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { BasicPanel } from "@goodgamestudios/core";
import { BasicToolTipManager } from "@goodgamestudios/core";

import { TextFieldType } from "@goodgamestudios/createjs-utilities";
import { TextField } from "@goodgamestudios/createjs-utilities";

import { BasicTutorialController } from "../../../basic/controller/BasicTutorialController";
import { Poker2SoundController } from "../../controller/Poker2SoundController";
import { Poker2PanelEvent } from "../../event/Poker2PanelEvent";
import { Poker2TutorialEvent } from "../../event/Poker2TutorialEvent";

import DisplayObject = createjs.DisplayObject;
import MouseEvent = createjs.MouseEvent;
import Container = createjs.Container;

export class Poker2Panel extends BasicPanel {
    public index: number = 0;

    protected static PANEL_INDEX_TUTORIAL: number = 120;
    protected _allowCaching: boolean = false;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
        disp.addEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOver));
        disp.addEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOut));
        BasicController.getInstance().addEventListener("tutorialstatechange", this.bindFunction(this.onTutorialEvent));
    }

    protected init(): void {
        super.init();

        (this.disp as Container).changeTextFieldCacheScale(2);
    }

    public destroy(): void {
        super.destroy();
        this.disp.removeEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOver));
        this.disp.removeEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOut));
        BasicController.getInstance().removeEventListener("tutorialstatechange", this.bindFunction(this.onTutorialEvent));

        if (this.dispToCache.cacheCanvas) {
            this.dispToCache.uncache();
        }
    }

    protected updateTextField(textField: TextField): void {
        Poker2LanguageFontManager.getInstance().changeFontByLanguage(textField);
    }

    protected get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }

    protected onMouseOver(event: MouseEvent): void {
        if (this._allowCaching && this.dispToCache.cacheCanvas) {
            this.dispToCache.uncache();
        }

        BasicController.getInstance().dispatchEvent(new Poker2PanelEvent("mouseonpanel"));
        super.onMouseOver(event);

        if (BasicToolTipManager.TOOLTIP_LABEL in event.target) {
            this.layoutManager.tooltipManager.show(event.target.toolTipText, event.target as DisplayObject);
        }
    }

    protected onMouseOut(event: MouseEvent): void {
        super.onMouseOut(event);

        if (BasicToolTipManager.TOOLTIP_LABEL in event.target)
            this.layoutManager.tooltipManager.hide();
    }

    protected onCursorOver(event: MouseEvent): void {
        if (event.target instanceof BasicButton)
            if ((event.target as BasicButton).enabled)
                this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);

        if (event.target instanceof TextField)
            if (event.target.type == TextFieldType.INPUT)
                this.layoutManager.customCursor.isEnabled = false;
    }

    protected onCursorOut(event: MouseEvent): void {
        this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);

        if (event.target instanceof TextField)
            if (event.target.type == TextFieldType.INPUT)
                this.layoutManager.customCursor.isEnabled = true;
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    public checkWaitingAnimState(message: string): void {
    }

    public updatePosition(): void {
        if (this.disp && this.disp.stage) {
            this.disp.scaleX = this.disp.scaleY = this.layoutManager.scaleFactor;
            this.disp.x = (this.disp.stage.stageWidth / 2) - ((800 / 2) * this.disp.scaleX);
        }
    }

    protected onClick(event: MouseEvent): void {
        if (event.target instanceof BasicButton) {
            this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_CLICK);
        }
    }

    protected onRollOut(event: MouseEvent): void {
        super.onRollOut(event);

        if (this._allowCaching) {
            this.dispToCache.doCache();
        }
    }

    protected onRollOver(event: MouseEvent): void {
        super.onRollOver(event);

        if (this._allowCaching && this.dispToCache.cacheCanvas) {
            this.dispToCache.uncache();
        }
    }

    protected get controller(): BasicController {
        return BasicController.getInstance();
    }

    protected onTutorialEvent(event: Poker2TutorialEvent): void {
        switch (Poker2TutorialController.getInstance().tutorialState) {
            case BasicTutorialController.TUT_STATE_COMPLETED:
                this.controller.removeEventListener("tutorialstatechange", this.bindFunction(this.onTutorialEvent));
                this.unLockPanel();
                break;
            default:
                this.lockPanel();
                break;
        }
    }

    protected get tutorialController(): Poker2TutorialController {
        return Poker2TutorialController.getInstance();
    }

    public get allowCaching(): boolean {
        return this._allowCaching;
    }

    public set allowCaching(value: boolean) {
        this._allowCaching = value;

        if (this._allowCaching && !this.dispToCache.cacheCanvas) {
            this.dispToCache.doCache();
        }
        else if (!this._allowCaching && this.dispToCache.cacheCanvas) {
            this.dispToCache.uncache();
        }
        else {
            this.updateCache();
        }
    }

    public get dispToCache(): DisplayObject {
        return this.disp;
    }

    public updateCache(): void {
        if (this.dispToCache.cacheCanvas) {
            this.dispToCache.updateCache();
        }
    }

    /**
     * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
     */
    protected set env(value/*:IEnvironmentGlobals*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicPanel.prototype, "env").set.call(this, value);
    }
}

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";

import { Poker2TutorialController } from "../../controller/Poker2TutorialController";
import { Poker2LanguageFontManager } from "../Poker2LanguageFontManager";
import { Poker2LayoutManager } from "../Poker2LayoutManager";
